<template>
	<v-row>
		<v-col cols="12">
			<v-row>
				<v-col cols="12" class="py-0">
					<v-row>
						<v-col
							md="4"
							class="align-self-center fast-play-header left-header"
						>
							<v-img
								width="250"
								height="50"
								:src="require('assets/static/img/logo/fastpaytv_white.png')"
							/>
							<v-img width="40" height="40" src="./images/estrella1.png" />
						</v-col>
						<v-col md="4" class="fast-play-header">
							<v-row class="pick-numbers">
								<v-col md="6" class="text-center picks"> PICKS </v-col>
								<v-col md="6" class="text-center picks"> NUMBERS </v-col>
							</v-row>
						</v-col>
						<v-col
							md="4"
							class="text-center align-self-center card-header fast-play-header right-header"
						>
							PAYOUTS
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" class="py-0">
					<v-row align="stretch">
						<v-col
							md="4"
							class="d-flex order-1 order-md-1 flex-column white-background"
							v-if="results.entries.slice(1).length > 0"
						>
							<result-display
								v-for="result in results.entries.slice(1)"
								:key="result.sortition.id"
								:result="result"
							>
							</result-display>
						</v-col>
						<v-col
							cols="12"
							md="4"
							class="d-flex order-0 order-md-0 flex-column gray-background left-footer"
						>
							<upcoming-sortition
								id="upcoming-result"
								:upcoming-sortition="upcomingSortition"
								@refresh="fetchUpcomingSortition"
							></upcoming-sortition>
							<div class="card-header"><span>Winning Numbers</span></div>
							<result-display
								v-for="result in results.entries.slice(0, 1)"
								:key="result.sortition.id"
								:result="result"
							>
							</result-display>
							<img src="./images/logo.png" class="bottom-star" />
						</v-col>
						<v-col
							md="4"
							class="d-flex order-2 order-md-2 flex-column gray-background right-footer"
						>
							<!-- Playouts card -->
							<prizes-card v-if="showPrizes" :prizes="prizes"></prizes-card>
							<results-card
								v-if="showResults"
								:results-by-lottery="resultsToShow"
								display-horizontally
							></results-card>
						</v-col>
					</v-row>
				</v-col>
				<v-col id="page-url" cols="12" class="text-center py-0">
					<span>Visit our page {{ url }}</span>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import ResultDisplay from './ResultDisplay.vue';
import UpcomingSortition from './UpcomingSortition.vue';
import BaseBoard from '../BaseBoard.js';
import PrizesCard from './PrizesCard.vue';
import ResultsCard from '../../common/ResultsCard';

export default {
	name: 'Board',
	extends: BaseBoard,
	components: {
		ResultsCard,
		UpcomingSortition,
		ResultDisplay,
		PrizesCard
	}
};
</script>

<style
	scoped
	lang="scss">
@import 'css/variables';
/*@import "css/main";*/

.bottom-star {
	position: absolute;
	max-height: 140px;
	bottom: 0;
	left: 250px;
}

.fast-play-header {
	height: 76px;
	background-color: $blue;
	color: $darkblue;
}

.right-header {
	border-top-right-radius: 20px;
}

.left-header {
	border-top-left-radius: 20px;
}

.right-footer {
	border-bottom-right-radius: 20px;
}

.left-footer {
	border-bottom-left-radius: 20px;
}

.pick-numbers {
	font-size: 1.7rem;
	color: $darkblue;
}

.picks {
	padding-top: 0;
}

.result-display {
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
}

.v-card {
	background-color: #3b3b3b;
	color: $blue;
	border-radius: 30px;

	&:not(#primary-card) {
		box-shadow: 8px 6px 20px 0 #07000080;
	}
}

::v-deep .v-card #countdown {
	line-height: 60px;
	text-align: center;
	font-family: 'RobotoBlack', serif;
}

#winning-numbers-text {
	line-height: 30px;
	color: $darkblue;
}

#upcoming-sortition {
	margin-top: 12px;
	margin-bottom: 12px;
}

.card-header {
	color: $darkblue;
	font-size: 1.7rem;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}

#page-url span {
	font-size: 1.4rem;
	color: $blue;
}

.gray-background {
	background-color: #dedede;
}

.white-background {
	background-color: white;
}
</style>
